import React from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import 'primereact/resources/themes/lara-dark-blue/theme.css'
import { LoginPage, useAuth } from '../features/Authentication'
import { ProtectedRoute } from '../components'
import Dashboard from '../features/Dashboard/page'
import HomePage from '../features/Landing/HomePage'

function LoginRoute() {
  const { isAuthenticated } = useAuth()
  if (isAuthenticated) return <Navigate to='/' replace />
  return <LoginPage onClose={() => window.history.back()} />
}

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginRoute />,
  },
  {
    path: '/dashboard/*',
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <Navigate to='/' replace />,
  },
]
